import React from 'react';

function PlusSign() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="8"
      viewBox="0 0 8 8"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="#CFDEB7">
          <path d="M5.333 0v3H8v2.333H5.333V8H3l-.001-2.667H0V3h3V0h2.333z" />
        </g>
      </g>
    </svg>
  );
}

export default PlusSign;
